import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import { ADMISION } from './Styles/StylesAdmision';

import logo from "../../assets/img/logo_menu_black.png";

class ListadoEstudiantesE extends Component {
    state = {  }
    semestre = (num) => {
        let romanos = ["I", "II", "III", "IV", "V", "VI","VII", "VIII", "IX", "X"];
        return (romanos[(num - 1)])
    }

    contenido = () => {
        let { seccion, estudiantes } = this.props;
        const styles = StyleSheet.create(ADMISION[0]);

        let nombre = (nombre) => {
            if (nombre === null) return "";
            return nombre;
        }

        let estudiants = () => {
            if (estudiantes.length === 0) return (
                <View style={[styles.row]}>
                    <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen estudiantes</Text>
                </View>
            )

            let num = 0;

            return (
                estudiantes.map(option => {
                    num++;
                    return (
                        <View key={option.id} style={[styles.row]}>
                            <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, styles.center]}>{num}</Text>
                            <View style={[styles.colTablaIngr1, styles.bordeCol9, styles.borderTop]}>
                                <Text style ={[styles.font8]}>
                                    {`${option.nacionalidad} ${option.ci}`}
                                </Text>
                                <Text style ={[styles.font8, {color: "#b41806"}]}>
                                    {option.email}
                                </Text>
                            </View>
                            <Text style={[styles.colTablaIngr1, styles.font9, styles.bordeCol9, styles.borderTop]}>{`${option.nombre_1} ${nombre(option.nombre_2)}`}</Text>
                            <Text style={[styles.colTablaIngr1, styles.font9, styles.bordeCol9, styles.borderTop]}>{`${option.apellido_1}  ${nombre(option.apellido_2)}`}</Text>
                        </View>
                    )
                })
            )
        }

        return (
            <React.Fragment>
                <View style={styles.row}>
                    <Image
                        style={[styles.colContent40, styles.logo]}
                        src={logo}
                    />
                    <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                        <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                        <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                    </View>
                </View>
                <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    LISTADO DE ESTUDIANTES INSCRITOS
                </Text>
                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DATOS DE LA SECCIÓN</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTablaInsc1, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>SEM.</Text>
                            <Text style={[styles.colTablaInsc2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>UNIDAD CURRICULAR</Text>
                            <Text style={[styles.colTablaInsc3, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>CÓDIGO</Text>
                            <Text style={[styles.colTablaInsc4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>CARRERA</Text>
                            <Text style={[styles.colTablaInsc3, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>SECCIÓN</Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTablaInsc1, styles.font9, styles.bordeCol11, styles.borderTop, styles.center]}>{this.semestre(seccion.semestreNum)}</Text>
                            <Text style={[styles.colTablaInsc2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>{seccion.materia}</Text>
                            <Text style={[styles.colTablaInsc3, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>{seccion.codigo}</Text>
                            <Text style={[styles.colTablaInsc4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>{seccion.carrera}</Text>
                            <Text style={[styles.colTablaInsc3, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>{seccion.seccioName}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. LISTADO DE ESTUDIANTES</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>N°</Text>
                            <Text style={[styles.colTablaInsc6, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>CÉDULA</Text>
                            <Text style={[styles.colTablaInsc7, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>APELLIDOS</Text>
                            <Text style={[styles.colTablaInsc7, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>NOMBRES</Text>
                        </View>
                        {estudiants()}
                    </View>
                </View>
                <View style={[styles.footer]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col6]}>
                        <Text style={[styles.linea3]}></Text>
                            <Text style={[styles.encabezado2]}>
                                Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                C.P.1061  Edo Miranda - Caracas - Venezuela
                            </Text>
                            <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                Telefax: +58 212 9930983 | 9939139 | 9910710.
                            </Text>
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }

    render() { 
        const styles = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={styles.section}>
                <Document title="Listado de Estudiantes Inscritos">
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenido()}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default ListadoEstudiantesE;


// WEBPACK FOOTER //
// ./src/components/Reportes/ListadoEstudiantesE.jsx